module.exports = __webpack_public_path__ + "img/play-store.6ecb348c.png";